/* [Directives] */
import clickOutside from './clickOutside';
import legoTooltip from './legoTooltip';
import columnsResizable from './columnsResizable';

export default function install(Vue) {
  Vue.use(clickOutside);
  Vue.use(legoTooltip);
  Vue.use(columnsResizable);
}
